import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isReplaceTextValueArgs(obj: any): CsvConfigJsonResult {
  const keysToValidate = [
    {key: 'decimalPlaces', type: 'number'},
    {key: 'showUnits', type: 'boolean'},
  ];

  let {result, errors} = validateObject(obj, keysToValidate);

  if (obj.conversionFactor !== undefined && typeof obj.conversionFactor !== 'number') {
    result = false;
    errors.push({code: 'notNumber', key: 'conversionFactor', value: obj.conversionFactor});
  }

  if (obj.conversionFactorOperation !== undefined) {
    const validConversion = ['addition', 'subtraction', 'division', 'multiplication'];

    if (!validConversion.includes(obj.conversionFactorOperation)) {
      result = false;
      errors.push({code: 'invalidValue', key: 'conversionFactorOperation', value: obj.conversionFactorOperation});
    }
  }

  return {result: result, errors: errors};
}

function validateObject(obj: any, requiredKeys: { key: string, type: string }[]): CsvConfigJsonResult {
  let valid = true;
  const errors = [];

  for (const {key, type} of requiredKeys) {
    if (obj[key] === undefined) {
      valid = false;
      errors.push({code: 'notExist', key});
    } else if (typeof obj[key] !== type) {
      valid = false;
      errors.push({code: `not${type[0].toUpperCase() + type.slice(1)}`, key, value: obj[key]});
    }
  }
  return {result: valid, errors};
}
